import {
    CLEAR_HOME_DATA,
    GET_HOME_DATA,
    SET_ANNOUNCEMENTS,
    SET_HOME_JOBS,
} from "./availableActions";
import {
    ClearHomeDataAction,
    GetHomeDataAction,
    SetAnnouncementsAction,
    SetHomeJobsAction,
} from "../../interfaces/store/actions/home";
import {
    AnnouncementData,
    JobsHomeData,
} from "../../interfaces/store/actions/payload/home";

export const getHomeData = (): GetHomeDataAction => ({
    type: GET_HOME_DATA,
});

export const setHomeJobs = (payload: JobsHomeData): SetHomeJobsAction => ({
    type: SET_HOME_JOBS,
    payload,
});

export const clearHomeData = (): ClearHomeDataAction => ({
    type: CLEAR_HOME_DATA,
});

export const setAnnouncements = (payload: AnnouncementData[]): SetAnnouncementsAction => ({
    type: SET_ANNOUNCEMENTS,
    payload,
});
